import { Route, RouteProps } from 'react-router-dom';
import { usePermissions, useFlags, useAccessLevel, useAppContext } from 'core/app/AppContext';
import { NotAuthorisedPage, NotFoundPage } from 'core/ui/components/error';
import { Permission, AccessLevel } from 'entities/user';

interface Props extends RouteProps {
  requiredPermissions?: Permission[];
  requiredAccessLevel?: AccessLevel;
  /**
   * @deprecated Prefer useFeatureFlag hook instead.
   * For more info: https://github.com/SaleCycle/my-salecycle-com/wiki/Feature-Flags
   */
  requiredFlags?: string[];
}

export function AuthorisedRoute({ component: ComponentToRender, ...rest }: Props) {
  const { isAppStateLoading } = useAppContext();
  const { accessLevel, isBrandAuthorised, isSiteAuthorised } = useAccessLevel();
  const { hasPermissionsAll } = usePermissions();
  const { hasFlags } = useFlags();

  return (
    <Route
      {...rest}
      render={routeProps => {
        if (isAppStateLoading) {
          return null;
        }

        let isAuthorised = hasPermissionsAll(rest.requiredPermissions);
        if (isAuthorised && rest.requiredAccessLevel) {
          isAuthorised = accessLevel === rest.requiredAccessLevel;
        }
        const brandId = routeProps?.match?.params?.brandId;
        if (isAuthorised && brandId) {
          isAuthorised = isBrandAuthorised(brandId);
        }
        const siteId = routeProps?.match?.params?.siteId;
        if (isAuthorised && siteId) {
          isAuthorised = isSiteAuthorised(siteId);
        }
        const isEnabled = hasFlags(rest.requiredFlags);

        if (isEnabled && isAuthorised) {
          return <ComponentToRender {...routeProps} />;
        } else if (!isEnabled) {
          return <NotFoundPage />;
        } else if (!isAuthorised) {
          return <NotAuthorisedPage />;
        } else {
          return <NotFoundPage />;
        }
      }}
    />
  );
}
